// ラベル
export const LABELS = {
  TITLE: "参照グループを選択してください。",
  ATTENTION:
    "参照グループ名は入金口座情報照会（詳細）画面からご確認いただけます。",
} as const;
